import React from "react"
import { ShimmerSimpleGallery } from "react-shimmer-effects"
import { Col, Row } from "reactstrap"

const ItemShimmer = () => {
  return (
    <Row className="item_shimmer">
      <Col lg={6} className="pe-0 first">
        <ShimmerSimpleGallery card imageHeight={225} col={3} row={2} />
      </Col>
      <Col lg={6} className="ps-0 second">
        <ShimmerSimpleGallery card imageHeight={225} col={3} row={2} />
      </Col>
    </Row>
  )
}

export default ItemShimmer
